export default function MenuIcon({ active = false }: { active?: boolean }) {
  return (
    <div
      className={`w-12 h-12 flex justify-center items-center rounded-full border cursor-pointer transition-colors ${
        active ? 'border-primary-400 bg-gray-800' : 'border-gray-800 hover:bg-gray-800'
      }`}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.125 0.75H13.875V2H0.125V0.75ZM0.125 6.375H13.875V7.625H0.125V6.375ZM0.125 12H13.875V13.25H0.125V12Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
